import {
  co,
  f,
  h,
  r,
  u
} from "./chunk.YLDBZ3SZ.js";
import {
  __decorateClass,
  __privateAdd,
  __privateGet,
  __privateMethod,
  __privateSet,
  __publicField
} from "./chunk.SZE6ONST.js";

// node_modules/@lit/reactive-element/decorators/custom-element.js
var t = (t3) => (e3, o2) => {
  void 0 !== o2 ? o2.addInitializer(() => {
    customElements.define(t3, e3);
  }) : customElements.define(t3, e3);
};

// node_modules/@lit/reactive-element/decorators/property.js
var o = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f };
var r2 = (t3 = o, e3, r5) => {
  const { kind: n2, metadata: i } = r5;
  let s = globalThis.litPropertyMetadata.get(i);
  if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = /* @__PURE__ */ new Map()), s.set(r5.name, t3), "accessor" === n2) {
    const { name: o2 } = r5;
    return { set(r6) {
      const n3 = e3.get.call(this);
      e3.set.call(this, r6), this.requestUpdate(o2, n3, t3);
    }, init(e4) {
      return void 0 !== e4 && this.P(o2, void 0, t3), e4;
    } };
  }
  if ("setter" === n2) {
    const { name: o2 } = r5;
    return function(r6) {
      const n3 = this[o2];
      e3.call(this, r6), this.requestUpdate(o2, n3, t3);
    };
  }
  throw Error("Unsupported decorator location: " + n2);
};
function n(t3) {
  return (e3, o2) => "object" == typeof o2 ? r2(t3, e3, o2) : ((t4, e4, o3) => {
    const r5 = e4.hasOwnProperty(o3);
    return e4.constructor.createProperty(o3, r5 ? { ...t4, wrapped: true } : t4), r5 ? Object.getOwnPropertyDescriptor(e4, o3) : void 0;
  })(t3, e3, o2);
}

// node_modules/@lit/reactive-element/decorators/state.js
function r3(r5) {
  return n({ ...r5, state: true, attribute: false });
}

// node_modules/@lit/reactive-element/decorators/event-options.js
function t2(t3) {
  return (n2, o2) => {
    const c = "function" == typeof n2 ? n2 : n2[o2];
    Object.assign(c, t3);
  };
}

// node_modules/@lit/reactive-element/decorators/base.js
var e = (e3, t3, c) => (c.configurable = true, c.enumerable = true, Reflect.decorate && "object" != typeof t3 && Object.defineProperty(e3, t3, c), c);

// node_modules/@lit/reactive-element/decorators/query.js
function e2(e3, r5) {
  return (n2, s, i) => {
    const o2 = (t3) => t3.renderRoot?.querySelector(e3) ?? null;
    if (r5) {
      const { get: e4, set: r6 } = "object" == typeof s ? n2 : i ?? (() => {
        const t3 = Symbol();
        return { get() {
          return this[t3];
        }, set(e5) {
          this[t3] = e5;
        } };
      })();
      return e(n2, s, { get() {
        let t3 = e4.call(this);
        return void 0 === t3 && (t3 = o2(this), (null !== t3 || this.hasUpdated) && r6.call(this, t3)), t3;
      } });
    }
    return e(n2, s, { get() {
      return o2(this);
    } });
  };
}

// node_modules/@lit/reactive-element/decorators/query-async.js
function r4(r5) {
  return (n2, e3) => e(n2, e3, { async get() {
    return await this.updateComplete, this.renderRoot?.querySelector(r5) ?? null;
  } });
}

// src/internal/computedStyle.ts
var computedStyleMap = /* @__PURE__ */ new WeakMap();
function getComputedStyle2(el) {
  let computedStyle = computedStyleMap.get(el);
  if (!computedStyle && globalThis.window) {
    computedStyle = window.getComputedStyle(el);
    computedStyleMap.set(el, computedStyle);
  }
  return computedStyle ?? null;
}

// node_modules/style-observer/src/util/detect-bugs/transitionrun-loop.js
var dummy = document.createElement("div");
document.body.appendChild(dummy);
var property = "--bar-" + Date.now();
dummy.style.cssText = `${property}: 1; transition: ${property} 1ms step-start allow-discrete`;
var transitionrun_loop_default = new Promise((resolve) => {
  let eventsCount = 0;
  requestAnimationFrame(() => {
    setTimeout((_) => resolve(eventsCount > 1), 50);
    dummy.addEventListener("transitionrun", (_) => eventsCount++);
    dummy.style.setProperty(property, "2");
  });
}).finally(() => dummy.remove());

// node_modules/style-observer/src/util/detect-bugs/unregistered-transition.js
var dummy2 = document.createElement("div");
document.body.appendChild(dummy2);
var property2 = "--foo-" + Date.now();
dummy2.style.cssText = `${property2}: 1; transition: ${property2} 1ms step-start allow-discrete`;
var unregistered_transition_default = new Promise((resolve) => {
  requestAnimationFrame(() => {
    setTimeout((_) => resolve(true), 30);
    dummy2.addEventListener("transitionstart", (_) => resolve(false));
    dummy2.style.setProperty(property2, "2");
  });
}).finally((_) => dummy2.remove());

// node_modules/style-observer/src/util/detect-bugs.js
var bugs = {
  TRANSITIONRUN_EVENT_LOOP: true,
  UNREGISTERED_TRANSITION: true
};
transitionrun_loop_default.then((value) => {
  bugs.TRANSITIONRUN_EVENT_LOOP = value;
});
unregistered_transition_default.then((value) => {
  bugs.UNREGISTERED_TRANSITION = value;
});
var detected = Promise.all([transitionrun_loop_default, unregistered_transition_default]);
var detect_bugs_default = bugs;

// node_modules/style-observer/src/util/is-registered-property.js
function isRegisteredProperty(property3, window2 = globalThis) {
  let document2 = window2.document;
  let dummy4 = document2.createElement("div");
  document2.body.append(dummy4);
  let invalidValue = "foo(bar)";
  dummy4.style.setProperty(property3, invalidValue);
  let value = getComputedStyle(dummy4).getPropertyValue(property3);
  let ret = true;
  if (value === invalidValue) {
    let child = dummy4.appendChild(document2.createElement("div"));
    let inheritedValue = getComputedStyle(child).getPropertyValue(property3);
    ret = inheritedValue !== invalidValue;
  }
  dummy4.remove();
  return ret;
}

// node_modules/style-observer/src/util/gentle-register-property.js
var INITIAL_VALUES = {
  "<angle>": "0deg",
  "<color>": "transparent",
  "<custom-ident>": "none",
  "<image>": "linear-gradient(transparent 0% 100%)",
  "<integer>": "0",
  "<length>": "0px",
  "<length-percentage>": "0px",
  "<number>": "0",
  "<percentage>": "0%",
  "<resolution>": "1dppx",
  "<string>": "''",
  "<time>": "0s",
  "<transform-function>": "scale(1)",
  "<transform-list>": "scale(1)",
  "<url>": "url('')"
};
function gentleRegisterProperty(property3, meta = {}, window2 = globalThis) {
  let CSS = window2.CSS;
  if (!property3.startsWith("--") || !CSS.registerProperty || isRegisteredProperty(property3, window2)) {
    return;
  }
  let definition = {
    name: property3,
    syntax: meta.syntax || "*",
    inherits: meta.inherits ?? true
  };
  if (meta.initialValue !== void 0) {
    definition.initialValue = meta.initialValue;
  } else if (definition.syntax !== "*" && definition.syntax in INITIAL_VALUES) {
    definition.initialValue = INITIAL_VALUES[definition.syntax];
  }
  try {
    CSS.registerProperty(definition);
  } catch (e3) {
    let error = e3;
    let rethrow = true;
    if (e3 instanceof window2.DOMException) {
      if (e3.name === "InvalidModificationError") {
        rethrow = false;
      } else if (e3.name === "SyntaxError") {
        definition.syntax = "*";
        try {
          CSS.registerProperty(definition);
          rethrow = false;
        } catch (e4) {
          error = e4;
        }
      }
    }
    if (rethrow) {
      throw new Error(`Failed to register custom property ${property3}: ${error.message}`, {
        cause: error
      });
    }
  }
}

// node_modules/style-observer/src/util/MultiWeakMap.js
var MultiWeakMap = class extends WeakMap {
  has(key, value) {
    if (arguments.length === 1) {
      return super.has(key);
    }
    let set = super.get(key);
    return set?.has(value) || false;
  }
  add(key, value) {
    let set = super.get(key) ?? /* @__PURE__ */ new Set();
    set.add(value);
    super.set(key, set);
  }
  delete(key, ...values) {
    let set = super.get(key);
    if (set) {
      for (let value of values) {
        set.delete(value);
      }
      if (set.size === 0) {
        super.delete(key);
      }
    }
  }
};

// node_modules/style-observer/src/util.js
function toArray(value) {
  if (value === void 0 || value === null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value !== "string" && typeof value[Symbol.iterator] === "function") {
    return Array.from(value);
  }
  return [value];
}
function wait(ms) {
  if (ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  return new Promise((resolve) => requestAnimationFrame(resolve));
}
var dummy3;
function getLonghands(property3) {
  dummy3 ?? (dummy3 = document.createElement("div"));
  let style = dummy3.style;
  style[property3] = "inherit";
  let ret = [...style];
  if (ret.length === 0) {
    ret = [property3];
  }
  style.cssText = "";
  return ret;
}
function parseTimes(cssTime) {
  let matches = cssTime.matchAll(/(?:^|\s)([+-]?(?:\d+|\d*\.\d+))\s*(ms|s)?(?=\s|$)/g);
  let ret = [];
  for (let match of matches) {
    let [, value, unit] = match;
    value = parseFloat(value);
    if (unit === "s") {
      value *= 1e3;
    }
    ret.push(value);
  }
  return ret;
}
function getTimesFor(property3, transitions) {
  transitions = splitCommas(transitions);
  let propertyRegex;
  if (property3 === "all") {
    propertyRegex = /\b\w+\b/g;
  } else {
    let properties = [.../* @__PURE__ */ new Set([...getLonghands(property3), property3, "all"])];
    propertyRegex = RegExp(`(?:^|\\s)(${properties.join("|")})\\b`);
  }
  let lastRelevantTransition = transitions.findLast((transition) => propertyRegex.test(transition));
  let times = lastRelevantTransition ? parseTimes(lastRelevantTransition) : [0, 0];
  if (times.length === 0) {
    times = [0, 0];
  } else if (times.length === 1) {
    times.push(0);
  }
  let [duration, delay] = times;
  return { duration, delay };
}
function splitCommas(value) {
  let ret = [];
  let lastIndex = 0;
  let stack = [];
  for (let match of value.matchAll(/[,()]/g)) {
    let char = match[0];
    if (char === ",") {
      if (stack.length === 0) {
        let item = value.slice(lastIndex, match.index);
        ret.push(item.trim());
        lastIndex = match.index + 1;
      }
    } else if (char === "(") {
      stack.push("(");
    } else if (char === ")") {
      stack.pop();
    }
  }
  if (lastIndex < value.length) {
    let item = value.slice(lastIndex);
    ret.push(item.trim());
  }
  return ret;
}

// node_modules/style-observer/src/rendered-observer.js
var _targets, _intersectionObservers;
var RenderedObserver = class {
  constructor(callback) {
    /**
     * All currently observed targets
     * @type {WeakSet<Element>}
     */
    __privateAdd(this, _targets, /* @__PURE__ */ new Set());
    /**
     * Documents to IntersectionObserver instances
     * @type {WeakMap<Document, IntersectionObserver>}
     */
    __privateAdd(this, _intersectionObservers, /* @__PURE__ */ new WeakMap());
    this.callback = callback;
  }
  /**
   * Begin observing the presence of an element.
   * @param {Element} element - The element to observe.
   */
  observe(element) {
    if (__privateGet(this, _targets).has(element)) {
      return;
    }
    let doc = element.ownerDocument;
    let io = __privateGet(this, _intersectionObservers).get(doc);
    if (!io) {
      io = new IntersectionObserver(
        (entries) => {
          this.callback(entries.map(({ target }) => ({ target })));
        },
        { root: doc.documentElement }
      );
      __privateGet(this, _intersectionObservers).set(doc, io);
    }
    __privateGet(this, _targets).add(element);
    io.observe(element);
  }
  /**
   * Stop observing the presence of an element.
   * @param {Element} [element] - The element to stop observing. If not provided, all targets will be unobserved.
   */
  unobserve(element) {
    if (!element) {
      for (const target of __privateGet(this, _targets)) {
        this.unobserve(target);
      }
      return;
    }
    let doc = element.ownerDocument;
    let io = __privateGet(this, _intersectionObservers).get(doc);
    io?.unobserve(element);
    __privateGet(this, _targets).delete(element);
  }
};
_targets = new WeakMap();
_intersectionObservers = new WeakMap();

// node_modules/style-observer/src/element-style-observer.js
gentleRegisterProperty("--style-observer-transition", { inherits: false });
var _initialized, _ElementStyleObserver_instances, init_fn, _inlineTransition;
var ElementStyleObserver = class {
  /**
   * @param {Element} target
   * @param {StyleObserverCallback} callback
   * @param {StyleObserverOptions} options
   */
  constructor(target, callback, options = {}) {
    __privateAdd(this, _ElementStyleObserver_instances);
    /**
     * Observed properties to their old values.
     * @type {Map<string, string>}
     */
    __publicField(this, "properties");
    /**
     * The element being observed.
     * @type {Element}
     */
    __publicField(this, "target");
    /**
     * The callback to call when the element's style changes.
     * @type {StyleObserverCallback}
     */
    __publicField(this, "callback");
    /**
     * The observer options.
     * @type {StyleObserverOptions}
     */
    __publicField(this, "options");
    /**
     * Whether the observer has been initialized.
     * @type {boolean}
     * @private
     */
    __privateAdd(this, _initialized, false);
    /**
     * @type { string | undefined }
     */
    __privateAdd(this, _inlineTransition);
    this.constructor.all.add(target, this);
    this.properties = /* @__PURE__ */ new Map();
    this.target = target;
    this.callback = callback;
    this.options = { properties: [], ...options };
    let properties = toArray(options.properties);
    this.renderedObserver = new RenderedObserver((records) => {
      if (this.propertyNames.length > 0) {
        this.handleEvent();
      }
    });
    if (properties.length > 0) {
      this.observe(properties);
    }
  }
  /**
   * Get the names of all properties currently being observed.
   * @type { string[] }
   */
  get propertyNames() {
    return [...this.properties.keys()];
  }
  resolveOptions(options) {
    return Object.assign(resolveOptions(options), this.options);
  }
  /**
   * Handle a potential property change
   * @private
   * @param {TransitionEvent} [event]
   */
  async handleEvent(event) {
    if (event && !this.properties.has(event.propertyName)) {
      return;
    }
    if (detect_bugs_default.TRANSITIONRUN_EVENT_LOOP && event?.type === "transitionrun" || this.options.throttle > 0) {
      let eventName = detect_bugs_default.TRANSITIONRUN_EVENT_LOOP ? "transitionrun" : "transitionstart";
      let delay = Math.max(this.options.throttle, 50);
      if (detect_bugs_default.TRANSITIONRUN_EVENT_LOOP) {
        let times = getTimesFor(
          event.propertyName,
          getComputedStyle(this.target).transition
        );
        delay = Math.max(delay, times.duration + times.delay + 16);
      }
      this.target.removeEventListener(eventName, this);
      await wait(delay);
      this.target.addEventListener(eventName, this);
    }
    let cs = getComputedStyle(this.target);
    let records = [];
    for (let property3 of this.propertyNames) {
      let value = cs.getPropertyValue(property3);
      let oldValue = this.properties.get(property3);
      if (value !== oldValue) {
        records.push({ target: this.target, property: property3, value, oldValue });
        this.properties.set(property3, value);
      }
    }
    if (records.length > 0) {
      this.callback(records);
    }
  }
  /**
   * Observe the target for changes to one or more CSS properties.
   * @param {string | string[]} properties
   * @return {void}
   */
  observe(properties) {
    properties = toArray(properties);
    properties = properties.filter((property3) => !this.properties.has(property3));
    if (properties.length === 0) {
      return;
    }
    __privateMethod(this, _ElementStyleObserver_instances, init_fn).call(this);
    let cs = getComputedStyle(this.target);
    for (let property3 of properties) {
      if (detect_bugs_default.UNREGISTERED_TRANSITION && !this.constructor.properties.has(property3)) {
        gentleRegisterProperty(property3, void 0, this.target.ownerDocument.defaultView);
        this.constructor.properties.add(property3);
      }
      let value = cs.getPropertyValue(property3);
      this.properties.set(property3, value);
    }
    if (detect_bugs_default.TRANSITIONRUN_EVENT_LOOP) {
      this.target.addEventListener("transitionrun", this);
    }
    this.target.addEventListener("transitionstart", this);
    this.target.addEventListener("transitionend", this);
    this.updateTransitionProperties();
    this.renderedObserver.observe(this.target);
  }
  /**
   * Update the `--style-observer-transition` property to include all observed properties.
   */
  updateTransitionProperties() {
    this.target.style.setProperty("--style-observer-transition", "");
    let transitionProperties = new Set(
      getComputedStyle(this.target).transitionProperty.split(", ")
    );
    let properties = [];
    for (let observer of this.constructor.all.get(this.target)) {
      properties.push(...observer.propertyNames);
    }
    properties = [...new Set(properties)];
    let transition = properties.filter((property3) => !transitionProperties.has(property3)).map((property3) => `${property3} 1ms step-start`).join(", ");
    this.target.style.setProperty("--style-observer-transition", transition);
  }
  /**
   * Update the target's transition property or refresh it if it was overwritten.
   * @param {object} options
   * @param {boolean} [options.firstTime] - Whether this is the first time the transition is being set.
   */
  updateTransition({ firstTime } = {}) {
    const sot = "var(--style-observer-transition, --style-observer-noop)";
    const inlineTransition = this.target.style.transition;
    let transition;
    if (firstTime ? inlineTransition : !inlineTransition.includes(sot)) {
      transition = __privateSet(this, _inlineTransition, inlineTransition);
    }
    if (transition === void 0 && (firstTime || !__privateGet(this, _inlineTransition))) {
      if (inlineTransition.includes(sot)) {
        this.target.style.transition = "";
      }
      transition = getComputedStyle(this.target).transition;
    }
    if (transition === "all") {
      transition = "";
    }
    const prefix = transition ? transition + ", " : "";
    this.target.style.setProperty("transition", prefix + sot, "important");
    this.target.style.setProperty("transition-behavior", "allow-discrete", "important");
    this.updateTransitionProperties();
  }
  /**
   * Stop observing a target for changes to one or more CSS properties.
   * @param { string | string[] } [properties] Properties to stop observing. Defaults to all observed properties.
   * @return {void}
   */
  unobserve(properties) {
    properties = toArray(properties);
    properties = properties.filter((property3) => this.properties.has(property3));
    for (let property3 of properties) {
      this.properties.delete(property3);
    }
    if (this.properties.size === 0) {
      this.target.removeEventListener("transitionrun", this);
      this.target.removeEventListener("transitionstart", this);
      this.target.removeEventListener("transitionend", this);
      this.renderedObserver.unobserve(this.target);
    }
    this.updateTransitionProperties();
  }
};
_initialized = new WeakMap();
_ElementStyleObserver_instances = new WeakSet();
/**
 * Called the first time observe() is called to initialize the target.
 */
init_fn = function() {
  if (__privateGet(this, _initialized)) {
    return;
  }
  let firstTime = this.constructor.all.get(this.target).size === 1;
  this.updateTransition({ firstTime });
  __privateSet(this, _initialized, true);
};
_inlineTransition = new WeakMap();
/** All properties ever observed by this class. */
__publicField(ElementStyleObserver, "properties", /* @__PURE__ */ new Set());
/**
 * All instances ever observed by this class.
 */
__publicField(ElementStyleObserver, "all", new MultiWeakMap());
function resolveOptions(options) {
  if (!options) {
    return {};
  }
  if (typeof options === "string" || Array.isArray(options)) {
    options = { properties: toArray(options) };
  } else if (typeof options === "object") {
    options = { properties: [], ...options };
  }
  return options;
}

// src/styles/shadow/component.css
var component_default = ":host {\n  box-sizing: border-box !important;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit !important;\n}\n\n[hidden] {\n  display: none !important;\n}\n";

// src/internal/webawesome-element.ts
var _hasRecordedInitialProperties;
var _WebAwesomeElement = class _WebAwesomeElement extends h {
  constructor() {
    super();
    this.didSSR = co || Boolean(this.shadowRoot);
    __privateAdd(this, _hasRecordedInitialProperties, false);
    // Store the constructor value of all `static properties = {}`
    this.initialReflectedProperties = /* @__PURE__ */ new Map();
    /** Metadata about CSS-settable props on this element */
    this.cssProps = {};
    this.computedStyle = null;
    this.styleObserver = null;
    try {
      this.internals = this.attachInternals();
    } catch (_e) {
      console.error("Element internals are not supported in your browser. Consider using a polyfill");
    }
    this.toggleCustomState("wa-defined");
    let Self = this.constructor;
    for (let [property3, spec] of Self.elementProperties) {
      if (spec.default === "inherit" && spec.initial !== void 0 && typeof property3 === "string") {
        this.toggleCustomState(`initial-${property3}-${spec.initial}`);
      }
    }
  }
  /** The base styles property will only get called if the subclass does not define a styles property of its own */
  static get styles() {
    const shadowStyle = this.shadowStyle ? Array.isArray(this.shadowStyle) ? this.shadowStyle : [this.shadowStyle] : [];
    const shadowStyles = [component_default, ...shadowStyle].map(
      (style) => typeof style === "string" ? r(style) : style
    );
    return shadowStyles;
  }
  connectedCallback() {
    super.connectedCallback();
    const Self = this.constructor;
    let cssProps = Object.keys(Self.cssProps);
    if (cssProps.length > 0) {
      let properties = [];
      if (Object.keys(this.cssProps).length === 0) {
        this.cssProps = Object.fromEntries(
          cssProps.map((property3) => {
            let setVia = this.getSetVia(property3);
            return [property3, { setVia }];
          })
        );
      }
      for (let property3 in this.cssProps) {
        let setVia = this.cssProps[property3].setVia;
        if (!setVia || setVia === "css") {
          properties.push(property3);
        }
      }
      this.handleCSSPropertyChange(properties);
      this.styleObserver ?? (this.styleObserver = new ElementStyleObserver(this, (records) => {
        let cssProperties = new Set(records.map((record) => record.property));
        let properties2 = cssProps.filter((property3) => {
          let cssProperty = Self.cssProps[property3].cssProperty;
          return cssProperties.has(cssProperty);
        });
        this.handleCSSPropertyChange(properties2);
      }));
      this.styleObserver.unobserve();
      this.styleObserver.observe(properties.map((property3) => Self.cssProps[property3].cssProperty));
    }
  }
  /**
   * Respond to CSS property changes for CSS properties reflecting props
   * @param [properties] - Prop names. Defaults to all CSS-reflected props.
   * @void
   */
  handleCSSPropertyChange(properties) {
    const Self = this.constructor;
    properties ?? (properties = Object.keys(Self.cssProps));
    properties = Array.isArray(properties) ? properties : [properties];
    if (properties.length === 0) {
      return;
    }
    this.computedStyle ?? (this.computedStyle = getComputedStyle2(this));
    for (let property3 of properties) {
      let propOptions = Self.cssProps[property3];
      let cssProperty = propOptions?.cssProperty;
      let meta = this.cssProps[property3];
      if (!cssProperty || meta.setVia && meta.setVia !== "css") {
        continue;
      }
      const value = this.computedStyle?.getPropertyValue(cssProperty);
      if (value) {
        meta.setVia = "css";
        meta.updating = true;
        this[property3] = value.trim();
        this.updateComplete.then(() => {
          meta.updating = false;
        });
      }
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!__privateGet(this, _hasRecordedInitialProperties)) {
      this.constructor.elementProperties.forEach(
        (obj, prop) => {
          if (obj.reflect && this[prop] != null) {
            this.initialReflectedProperties.set(prop, this[prop]);
          }
        }
      );
      __privateSet(this, _hasRecordedInitialProperties, true);
    }
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.initialReflectedProperties.forEach((value, prop) => {
      if (changedProperties.has(prop) && this[prop] == null) {
        this[prop] = value;
      }
    });
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    if (this.didSSR) {
      this.shadowRoot?.querySelectorAll("slot").forEach((slotElement) => {
        slotElement.dispatchEvent(new Event("slotchange", { bubbles: true, composed: false, cancelable: false }));
      });
    }
  }
  /**
   * Get how a prop was set
   * @param property - The property to check
   */
  getSetVia(property3) {
    let Self = this.constructor;
    let setVia;
    let propOptions = Self.cssProps[property3];
    let attribute = typeof propOptions.attribute === "string" ? propOptions.attribute : property3;
    if (propOptions.attribute !== false && this.hasAttribute(attribute)) {
      setVia = "attribute";
    } else {
      let value = this[property3];
      if (value !== void 0 && value !== propOptions.default) {
        setVia = "js";
      }
    }
    return setVia;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    let Self = this.constructor;
    let cssProps = Object.keys(Self.cssProps);
    if (cssProps.length === 0) {
      return;
    }
    for (let [property3] of changedProperties) {
      let meta = this.cssProps[property3];
      if (meta && typeof property3 === "string" && !(meta.setVia === "css" && meta.updating)) {
        meta.setVia = this.getSetVia(property3);
      }
    }
  }
  update(changedProperties) {
    try {
      super.update(changedProperties);
    } catch (e3) {
      if (this.didSSR && !this.hasUpdated) {
        const event = new Event("lit-hydration-error", { bubbles: true, composed: true, cancelable: false });
        event.error = e3;
        this.dispatchEvent(event);
      }
      throw e3;
    }
  }
  /** Checks if states are supported by the element */
  hasStatesSupport() {
    return Boolean(this.internals?.states);
  }
  /** Adds a custom state to the element. */
  addCustomState(state) {
    if (this.hasStatesSupport()) {
      this.internals.states.add(state);
    }
  }
  /** Removes a custom state from the element. */
  deleteCustomState(state) {
    if (this.hasStatesSupport()) {
      this.internals.states.delete(state);
    }
  }
  /** Toggles a custom state on the element. */
  toggleCustomState(state, force) {
    if (typeof force === "boolean") {
      if (force) {
        this.addCustomState(state);
      } else {
        this.deleteCustomState(state);
      }
      return;
    }
    this.toggleCustomState(state, !this.hasCustomState(state));
  }
  /** Determines if the element has the specified custom state. */
  hasCustomState(state) {
    return this.hasStatesSupport() ? this.internals.states.has(state) : false;
  }
  getComputed(prop) {
    let value = this[prop];
    if (value !== "inherit") {
      return value;
    }
    let Self = this.constructor;
    let options = Self.elementProperties.get(prop);
    for (let element = this; element.parentElement; element = element.parentElement) {
      value = element[prop];
      if (value !== "inherit") {
        return value;
      }
    }
    return options?.initial ?? options?.default ?? value;
  }
  /**
   * Given a native event, this function cancels it and dispatches it again from the host element using the desired
   * event options.
   */
  relayNativeEvent(event, eventOptions) {
    event.stopImmediatePropagation();
    this.dispatchEvent(
      new event.constructor(event.type, {
        ...event,
        ...eventOptions
      })
    );
  }
  getBoundingClientRect() {
    let rect = super.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) {
      let Self = this.constructor;
      if (Self.rectProxy) {
        let element = this[Self.rectProxy];
        if (element instanceof Element) {
          let childRect = element.getBoundingClientRect();
          if (childRect.width > 0 || childRect.height > 0) {
            return childRect;
          }
        }
      }
    }
    return rect;
  }
  static createProperty(name, options) {
    if (options) {
      if (options.initial !== void 0 && options.default === void 0) {
        options.default = "inherit";
      }
      if (options.default !== void 0 && options.converter === void 0) {
        let converter = {
          ...u,
          toAttribute(value, type) {
            if (value === options.default) {
              return null;
            }
            return u.toAttribute(value, type);
          }
        };
        options = { ...options, converter };
      }
    }
    super.createProperty(name, options);
    if (options) {
      if (options.cssProperty) {
        if (this.cssProps === _WebAwesomeElement.cssProps) {
          this.cssProps = {};
        }
        this.cssProps[name] = options;
      }
      if (options.default !== void 0) {
        const descriptor = Object.getOwnPropertyDescriptor(this.prototype, name);
        if (descriptor?.get) {
          const getter = descriptor.get;
          Object.defineProperty(this.prototype, name, {
            ...descriptor,
            get() {
              return getter.call(this) ?? options.default;
            }
          });
        }
      }
    }
  }
};
_hasRecordedInitialProperties = new WeakMap();
/**
 * Props that can be set via CSS custom properties
 */
_WebAwesomeElement.cssProps = {};
__decorateClass([
  n()
], _WebAwesomeElement.prototype, "dir", 2);
__decorateClass([
  n()
], _WebAwesomeElement.prototype, "lang", 2);
__decorateClass([
  n({ type: Boolean, reflect: true, attribute: "did-ssr" })
], _WebAwesomeElement.prototype, "didSSR", 2);
var WebAwesomeElement = _WebAwesomeElement;

export {
  t,
  n,
  r3 as r,
  t2,
  e2 as e,
  r4 as r2,
  getComputedStyle2 as getComputedStyle,
  WebAwesomeElement
};
/*! Bundled license information:

@lit/reactive-element/decorators/custom-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/property.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/event-options.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/base.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-async.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-all.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
